import { cn } from "@newxsystems/shared";
import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { IHeroBlockProps } from "./HeroBlock.props";

export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) return null;
  const isBackgroundHero = props.variant !== "split-image";

  return (
    <RavioliSection
      className={cn(props.parentClass, isBackgroundHero && "!py-0")}
      containerClassName={isBackgroundHero ? "!max-w-none !px-0" : "!px-0 md:!px-6"}
      containerWidth="wide"
      id={props.anchorId}
      spacing={props.spacing}
    >
      {props.variant === "split-image" ? (
        <HeroSplitImage {...props} />
      ) : (
        <HeroBackgroundImage {...props} />
      )}
    </RavioliSection>
  );
};

HeroBlock.displayName = "Block::HeroBlock";
